export default __webpack_public_path__ + "static/media/4.d7185eb0.png";